<template>
	<div class="counter">
		<div class="m_top">
			<van-search v-model="value" placeholder="请输入您要搜索的商品名称" @focus="tiao" />
			<div class="filter flex_a">
				<div :class="sortKey == '' ? 'color' : ''" @click="() => sortFg('')">
					综合
				</div>
				<div :class="sortKey == 'jinbi' ? 'color flex' : 'flex'" @click="() => sortFg('jinbi')">
					<div>积分</div>
					<div>
						<Iconfont name="iconarrLeft-fill" class="icon" size="0.6rem" :color="sortKey == 'jinbi' && orderType == 'asc' ? markColor : '#999999'
							" />
						<Iconfont name="iconsanjiao_xia" class="icon" size="0.6rem" :color="sortKey == 'jinbi' && orderType == 'desc'
							? markColor
							: '#999999'
							" />
					</div>
				</div>
				<div :class="sortKey == 'sales' ? 'color flex' : ' flex'" @click="() => sortFg('sales')">
					<div>兑换量</div>
					<div>
						<Iconfont name="iconarrLeft-fill" class="icon" size="0.6rem" :color="sortKey == 'sales' && orderType == 'asc' ? markColor : '#999999'
							" />
						<Iconfont name="iconsanjiao_xia" class="icon" size="0.6rem" :color="sortKey == 'sales' && orderType == 'desc'
							? markColor
							: '#999999'
							" />
					</div>
				</div>
			</div>
		</div>
		<div class="m_sideBar" :class="{ newMode: isNewMode }">
			<!-- 侧面标签栏 -->
			<van-sidebar v-model="activeKey" class="scrow">
				<van-sidebar-item v-for="item in title" :title="item.cate_name" :key="'cate' + item.cate_id"
					@click="change(item)" />
			</van-sidebar>
			<!-- 侧面标签栏 -->
			<div class="shop_list" ref='shop_list_scrol'  v-on:scroll="updateScroll" >
				<div class="shop_list_scrol" >
					<div v-if="isNewMode" class="box2">
						<div class="  " v-for="(god, idx) in goodsList" :key="idx" >
							<homeCard :itemObj='god' :isMinStyle='1' :is_show_price='is_show_price'></homeCard>
						</div>
					</div>
					<div v-else>
						<div class="box" v-for="god in goodsList" :key="'stock' + god.stock_id" @click="jump(god.stock_id, surl)">
							<div class="img">
								<img :src="god.goods_image" alt />
							</div>
							<div class="m_title">{{ god.goods_name }}</div>
							<div class="m_price">
								<!--            活动价-->
								<!--<i v-if="god.goods_active == 1">{{god.store_retail_price_format}}</i>-->
								<i>{{ god.jinbi }}</i>
								<p class="integral">积分</p>
							</div>
							<div class="jy_txt" v-if="is_show_price==1">建议兑换:{{god.retail_price}}</div>
						</div>
					</div>

				</div>

				<div v-if="goodsList.length > 6" class="onloading">
					{{ isOnload ? '加载中...' : '暂无更多' }}
				</div>
			</div>
		</div>
		<div class="zw"></div>
		<footer-view></footer-view>
	</div>
</template>

<script>
import {
	sendRequest
} from '../../assets/public'
import footerView from '@/components/footerView.vue'
import Iconfont from '@/components/iconfont.vue'
import homeCard from "@/components/homeCard.vue";
export default {
	components: {
		footerView,
		Iconfont,
		homeCard
	},
	data() {
		return {
			activeKey: 0,
			value: '',
			title: [],
			goodsList: [], //商品列表
			loading: false,
			finished: false,
			page: 1,
			limit: 10,
			cate_id: '',
			isOnload: true,
			surl: 'classUrl',
			orderType: 'asc',
			sortKey: '',
			markColor: '#FD3E3E',
			isNewMode: 0,
			boxScrollTop:0,
			// ClassScrollTop:localStorage.getItem('ClassScrollTop') || 0,//分类盒子跳转
		}
	},
	watch:{
		'$route'(to,from){
			if(to.path=='/shopDetail'){
			
				localStorage.setItem('ClassScrollTop',this.boxScrollTop)
			}
			if(from.path == '/shopDetail'){
				this.boxScrollTop = localStorage.getItem('ClassScrollTop')
				this.$refs.shop_list_scrol.scrollTo(0,this.boxScrollTop , 300);
			}
		}
	},
	async created() {
		if (localStorage.getItem('isNewMode')) {
			this.isNewMode = 1
		}
		let tcate = this.$route.query.cate_id || ''
		// 全部分类
		let {
			content
		} = await sendRequest('goods/category', {})
		this.title = content
		this.cate_id = tcate ? tcate : this.title[0].cate_id
		for (let item in content) {
			if (content[item].cate_id == this.cate_id) {
				this.activeKey = item
			}
		}
		this.page = 1
		this.getGods()
	},
	mounted() {
		document
			.querySelector('.shop_list')
			.addEventListener('scroll', this.handScroll)
	},

	methods: {
		updateScroll(event){
		
			this.boxScrollTop = event.target.scrollTop
		},
		// 切换排序
		sortFg(e) {
			if (this.sortKey == e) {
				this.orderType = this.orderType == 'asc' ? 'desc' : 'asc'
			} else {
				this.orderType = 'asc'
			}
			this.sortKey = e
			this.page = 1
			this.goodsList = []
			this.getGods()
		},
		handScroll() {
			if (!this.isOnload) {
				return
			}
			if (
				document.body.scrollHeight -
				document.querySelector('.m_top').offsetHeight +
				document.querySelector('.shop_list').scrollTop +
				30 >=
				document.querySelector('.shop_list_scrol').offsetHeight
			) {
				this.page = this.page + 1
				this.isOnload = false
				this.getGods()
			}
		},
		// 切换获取商品
		async change(item) {
			this.page = 1
			this.goodsList = []
			this.isOnload = true
			this.cate_id = item.cate_id
			this.getGods()
		},
		//获取商品列表
		async getGods() {
			let res = await sendRequest('goods/list', {
				cate_id: this.cate_id,
				goods_type: 0,
				page: this.page,
				limit: 10,
				order: this.sortKey,
				order_type: this.orderType,
			})
			if (res.status != 200) {
				return
			} else {
				if (res.content.list.length == 0) {
					this.isOnload = false
					return
				}
				setTimeout(() => {
					this.isOnload = true
				}, 200)
				let shopData = [...this.goodsList, ...res.content.list]
				this.goodsList = shopData
				this.is_show_price=res.content.is_show_retail_price
			}
		},
		jump(id, surl) {
			console.log(id, surl)
			this.$router.push({
				path: 'shopDetail',
				query: {
					id: id,
					surl: surl
				}
			})
			// this.$router.push({
			//     path: '/shopDetail?id=' + id
			// })
		},
		tiao() {
			this.$router.push({
				name: 'search',
			})
		},
	},
}
</script>

<style scoped>
.zw {
	width: 100%;
	height: 3.8rem;
}

.scrow {
	width: 3.5rem !important;

	height: 80vh;
	overflow: auto;
}

.m_sideBar.newMode .scrow {
	width: 3rem !important;
}

body {
	background: RGBA(246, 246, 246, 1);
}

.m_top {
	position: fixed;
	width: 100%;
	padding-top: 0.4rem;
	background: #ffffff;
}

.m_sideBar {
	position: fixed;
	display: flex;
	margin-top: 3.8rem;
}

.shop_list {
	width: 11.4rem;
	height: 78vh;
	overflow: auto;
}

.m_sideBar.newMode .shop_list {
	width: 12rem;
}

.shop_list_scrol {
	overflow: hidden;
}

.img {
	width: 4.6rem;
	height: 4.6rem;
	/* background: black; */
	margin: 0.2rem auto;
}

img {
	width: 100%;
	height: 100%;
}

.m_title {
	height: 1.4rem;
	padding: 0 0.2rem;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	overflow: hidden;
	line-height: 0.7rem;
	-webkit-box-orient: vertical;
	font-size: 0.48rem;
	font-family: PingFang SC;
	font-weight: 500;
	color: rgba(51, 51, 51, 1);
	margin-top: 0.64rem;
}

.m_price {
	display: flex;
	margin-top: 0.2rem;
	margin-left: 0.2rem;
}

.m_price i {
	font-style: normal;
	font-size: 0.6rem;
	font-family: PingFang SC;
	font-weight: bold;
	color: rgba(253, 62, 62, 1);
}

.integral {
	padding: 0.1rem 0.2rem;
	height: 0.52rem;
	line-height: 0.52rem;
	text-align: center;
	border: 1px solid rgba(253, 62, 62, 1);
	border-radius: 0.26rem;
	font-size: 0.36rem;
	font-family: PingFang SC;
	font-weight: 500;
	color: rgba(253, 62, 62, 1);
	/* margin-top: .7rem; */
	margin-left: 0.2rem;
}

.box {
	float: left;
	width: 5.1rem;
	/* height: 8.2rem; */
	background: rgba(255, 255, 255, 1);
	border-radius: 0.2rem;
	margin-left: 0.4rem;
	margin-bottom: 0.4rem;
}


.van-sidebar-item--select {
	color: red;
}

.onloading {
	width: 100%;
	text-align: center;
	font-size: 0.44rem;
	color: #333;
	padding: 0.2rem 0 0.4rem;
}

.redemption_tab .icon {
	margin-top: 0.4rem;
	margin-left: 0.2rem;
}

.icon {
	line-height: 0.3rem;
	display: block;
}

.iconarrLeft-fill {
	position: relative;
	top: 0.6rem;
}

.iconsanjiao_xia {
	position: relative;
	top: 0.6rem;
}

.filter {
	height: 1.68rem;
	line-height: 1.68rem;
	font-size: 0.52rem;
	font-family: PingFang SC;
	font-weight: 500;
	color: rgba(153, 153, 153, 1);
}

.color {
	color: #fe6157;
}

.van-search {
	padding-top: 0;
	padding-bottom: 0;
}

.counter {
	background: none;
}

.box2 {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	padding: 0 0.44rem;
}
</style>
<style type="text/css">
	.newMode .van-sidebar-item{
		padding: 0;
	}
	.newMode .van-sidebar-item__text{
		padding: 0.4rem 0;
		height: 2rem;
		line-height:2rem ;
		text-align: center;
		width: 100%;
	}
	.jy_txt{
		font-size: 0.40rem;
		color: #999;
		padding-bottom: 0.2rem;
		padding-left: 0.2rem;
	}
</style>